import { c as _c } from "react/compiler-runtime";
import { LeadsChartBox } from 'modules/main/components/chart-box-section/leads-chart-box';
import { RevenueChartBox } from 'modules/main/components/chart-box-section/revenue-chart-box';
import { MainFilterInterface } from 'modules/main/types/main-filter-interface';
export const ChartBoxSection = t0 => {
  const $ = _c(2);
  const {
    filter
  } = t0;
  let t1;
  if ($[0] !== filter) {
    t1 = <div className="flex min-w-0 flex-col gap-5"><RevenueChartBox filter={filter} /><LeadsChartBox filter={filter} /></div>;
    $[0] = filter;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};